import { publicAssetUrl } from '@wilkins-software/redwood-utils';

import {
  createExtrudedSvgThreeScene,
  type ExtrudedSvgThreeSceneHandle,
} from './extruded-svg-three-scene';

const RADIO_DEMON_MARK_URL = publicAssetUrl('images/radio-demon-radio.svg');

export type RadioDemonThreeSceneHandle = ExtrudedSvgThreeSceneHandle;

/**
 * Radio Demon showcase mark: extruded cathedral-radio SVG with warm amber
 * rim lighting. Thin wrapper around the shared enamel-pin scene factory.
 */
export async function createRadioDemonThreeScene(
  container: HTMLElement,
): Promise<RadioDemonThreeSceneHandle | null> {
  return createExtrudedSvgThreeScene(container, {
    svgUrl: RADIO_DEMON_MARK_URL,
    svgViewBoxHeight: 280,
    logoWorldHeight: 4.8,
    minShapeAreaSvgUnits: 40,
    rimLightColor: 0xf5a623,
    topRimLightColor: 0xffe8a0,
    sideKickerColor: 0xffd4a8,
    hemisphereSkyColor: 0xfff4e8,
    hemisphereGroundColor: 0x1a0f08,
  });
}
